import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Decor_feed.png'


const _withScopeId = n => (_pushScopeId("data-v-6bc69e1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view work" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "work__decor",
  src: _imports_0
}, null, -1))

import { Ref, onBeforeMount, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { WorksSevice, WorkItem } from '@/services/WorksService';
import BaseFeedCreation from '@/components/feed/BaseFeedCreation.vue';
import BaseBackLink from '@/components/shared/BaseBackLink.vue';
import BaseLoader from '@/components/shared/BaseLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkView',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const work: Ref<WorkItem | null> = ref(null);
onBeforeMount(async () => {
	if (typeof route.query.id !== 'string') return;

	// Get work
	WorksSevice.getWork(route.query.id).then(
		(_work) => (work.value = _work.work[0] ?? null)
	);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseBackLink, {
      onClick: _unref(router).back
    }, null, 8, ["onClick"]),
    (work.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (work.value)
            ? (_openBlock(), _createBlock(BaseFeedCreation, {
                key: work.value.id,
                id: work.value.id,
                format: "fullscreen",
                author: {
					user_id: work.value.owner_id,
					avatar: work.value.user_avatar,
					nickname: work.value.user_nickname
				},
                image: work.value.image_url,
                text: work.value.description,
                date: work.value.created_at,
                likes: work.value.likes_count,
                preview: work.value.preview,
                brand: work.value.brand_html
              }, null, 8, ["id", "author", "image", "text", "date", "likes", "preview", "brand"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock(BaseLoader, { key: 1 })),
    _hoisted_2
  ]))
}
}

})